<template>
	<div
		class="hours-switcher"
		:class="{ 'hours-switcher--menu-style': menuStyle }"
	>
		<div
			v-for="(label, index) in switcherLabels"
			class="hours-switcher__item"
			:class="{ active: activeTab === label }"
			:key="label"
			ref="hoursSwitcherItem"
			@click="switchActiveIndex(label, index)"
		>
			<div class="hours-switcher__item-name">
				{{ label }}
			</div>
		</div>
		<div class="active-line" :style="lineStyle"></div>
	</div>
</template>

<script>
export default {
	name: 'HoursSwitcher',

	props: {
		switcherLabels: {
			type: Array,
			required: true
		},
		activeTab: {
			type: String,
			default: 'Open'
		},
		menuStyle: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			lineStyle: {
				width: '0px',
				left: '0px'
			}
		}
	},

	mounted() {
		this.$nextTick(() => {
			this.updateLinePosition()
		})

		window.addEventListener('resize', this.handleResize)
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
	},

	methods: {
		handleResize() {
			this.updateLinePosition()
		},

		updateLinePosition(index) {
			const switcherItems = this.$refs.hoursSwitcherItem || []
			const activeIndex =
				index !== undefined
					? index
					: this.switcherLabels.indexOf(this.activeTab)

			if (activeIndex === -1 || !switcherItems[activeIndex]) return

			const activeCatEl = switcherItems[activeIndex]

			this.lineStyle = {
				width: `${activeCatEl.offsetWidth}px`,
				left: `${activeCatEl.offsetLeft}px`
			}
		},

		switchActiveIndex(label, index) {
			if (label === this.activeTab) return

			this.updateLinePosition(index)

			this.$emit('handle-change', label)
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.hours-switcher {
	position: sticky;
	top: 0;
	display: flex;
	align-items: center;
	max-width: 600px;
	margin: 0 auto 20px auto;
	overflow: hidden;
	background-color: $dark-blue;
	z-index: 2;

	&__item {
		width: 50%;
		text-align: center;
		padding: 3px 0;
		color: $white;
		cursor: pointer;
		position: relative;
		z-index: 5;
		opacity: 0.5;
		font-size: 16px;

		&__border {
			position: absolute;
			width: 100%;
			height: 3px;
			bottom: 0;
			left: 0;
			background-color: $white;
		}

		&.active {
			cursor: default;
			opacity: 1;
			font-size: 22px;
			border-bottom: 1px solid $white;
			padding-bottom: 18px;
		}
	}

	.active-line {
		position: absolute;
		bottom: 0;
		height: 3px;
		background-color: $white;
		transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
		pointer-events: none;
	}

	&--menu-style {
		position: relative;
		margin: 0;
		background-color: transparent;
		z-index: 1;

		@media (min-width: 480px) {
			width: 70%;
			max-width: 450px;
		}

		.hours-switcher__item {
			width: 33.3%;
			padding: 12.5px 12px;
			font-size: 14px;
			line-height: 19px;
			white-space: nowrap;
			text-transform: uppercase;
			gap: 36px;
			z-index: 1;
			opacity: 1;

			@media (min-width: 1024px) {
				transition: color 0.3s;

				&:hover:not(.active) {
					color: $blue;
				}
			}

			&.active {
				padding: 11px 12px;
				font-size: 16px;
				line-height: 22px;
				border-bottom: none;
			}
		}
		.hours-switcher__item-name {
			position: relative;
			display: inline-block;
		}
	}

	@media only screen and (max-width: 767px) {
		&__item {
			font-size: 14px;

			&.active {
				font-size: 20px;
			}
		}
	}
}
</style>
